 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import HTML00_COVER from '@/components/html/00_Cover'
 import HTMLLOVE_1 from '@/components/html/love_1'
 import HTML01_FRONT_MATTER from '@/components/html/01_Front_Matter'
 import HTML02_TITLE_PAGE from '@/components/html/02_Title_Page'
 import HTML04_DEDICATION from '@/components/html/04_Dedication'
 import HTML05_FRONT_MATTER from '@/components/html/05_Front_Matter'
 import HTML06_CONTENTS from '@/components/html/06_Contents'
 import HTML07_1_SAILING from '@/components/html/07_1_Sailing'
 import HTML08_2_HEARING from '@/components/html/08_2_Hearing'
 import HTML09_3_AID from '@/components/html/09_3_Aid'
 import HTML10_4_LOSS from '@/components/html/10_4_Loss'
 import HTML11_5_CONDUCTION from '@/components/html/11_5_Conduction'
 import HTML12_6_ROCK from '@/components/html/12_6_Rock'
 import HTML13_7_ACOUSTICS from '@/components/html/13_7_Acoustics'
 import HTML14_8_SILENCE from '@/components/html/14_8_Silence'
 import HTML15_9_DISTORTION from '@/components/html/15_9_Distortion'
 import HTML16_10_SIGN from '@/components/html/16_10_Sign'
 import HTML17_11_VISION from '@/components/html/17_11_Vision'
 import HTML18_12_SURFACING from '@/components/html/18_12_Surfacing'
 import HTML19_13_LISTENING from '@/components/html/19_13_Listening'
 import HTML20_14_MUSIC from '@/components/html/20_14_Music'
 import HTMLLOVE_2 from '@/components/html/love_2'
 import HTML21_FURTHER_READING from '@/components/html/21_Further_Reading'
 import HTML22_ACKNOWLEDGEMENTS from '@/components/html/22_Acknowledgements'
 import HTML03_COPYRIGHT_PAGE from '@/components/html/03_Copyright_Page'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/html/06_Contents",
 			"name" : "html/06_Contents",
 			"component" : HTML06_CONTENTS
 		},
 		{
 			"path" : "/html/07_1_Sailing",
 			"name" : "html/07_1_Sailing",
 			"component" : HTML07_1_SAILING
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js